const myAccountEventType = "my_account";
var MyAccountMenuPosition = /* @__PURE__ */ ((MyAccountMenuPosition2) => {
  MyAccountMenuPosition2["Header"] = "Drop-down list";
  MyAccountMenuPosition2["Sidebar"] = "Left list";
  return MyAccountMenuPosition2;
})(MyAccountMenuPosition || {});
export {
  MyAccountMenuPosition,
  myAccountEventType
};
//# sourceMappingURL=types.js.map
